import { Option } from '@/common/types';

export enum ScanStatuses {
  Yes = 'yes',
  No = 'no',
}
export const CIP_SYNTHETIC_ID = 'CIP_SYNTHETIC_ID';

export const CLOSE_CONTRIBUTION_SIDE = {
  EMPLOYEE: 'employee',
  EMPLOYER: 'employer',
};
export interface EmployeeCIPClosePaymentsForm {
  payment: string;
}

export interface EmployeeCIPCloseContributionForm {
  contributionTo: string;
}
export interface EmployeeCIPCloseForm
  extends EmployeeCIPCloseContributionForm,
    EmployeeCIPClosePaymentsForm {}
export interface QuestionPayloadOption {
  prompt: string;
  type: string;
  answer: string[];
}
export interface ResponsePayload {
  id_number: number;
  id_scan: string;
  id_scan_url?: string;

  // questions: {
  //   question: QuestionPayloadOption[]
  // }
}
export interface QuestionnaireField {
  key: string;
  label: string;
  options: Option[];
}

export interface QuestionnaireFormattedPayload {
  id: number;
  idScan: string;
  idScanUrl: string;
  questions: QuestionnaireField[];
}

export const AnswersStatus = {
  Challenge: 'challenge',
  Fail: 'fail',
  Pass: 'pass',
  Success: 'success',
};
